import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const ConsultationHistory = React.lazy(() =>
  import('../../views/ConsultationHistory/ConsultationHistory')
);

const params = [];

const ConsultationHistoryRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <ConsultationHistory />
      </Layout>
    </RouteParameter>
  );
};

ConsultationHistoryRoute.propTypes = {};

ConsultationHistoryRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ConsultationHistoryRoute);
